import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { LayoutService } from '@core/services';

import { info } from '@environment';

@Component({
  selector: 'z-copyright',
  templateUrl: './copyright.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopyrightComponent {
  @Input() displayLicenseMessage: boolean = true;

  copyrightYear = info.copyrightYear;
  companyName = info.companyName;

  constructor(public layoutService: LayoutService) {}
}
